// Canonical marketplace listing categories.
//
// ADD A NEW CATEGORY HERE ONLY. Every surface — API validation
// (listing-validation, vendor register, buyer requests) and all UI (home
// chips, browse filter, vendor listing form, listing cards/detail) — imports
// from this module, so validation and display can never drift.

export type Category = { value: string; label: string; emoji: string }

export const CATEGORIES: Category[] = [
  { value: 'ev_sales', label: 'EV Sales', emoji: '🚗' },
  { value: 'used_ev', label: 'Used EVs', emoji: '🚘' },
  { value: 'rental', label: 'Rentals', emoji: '🚙' },
  { value: 'accessories', label: 'Accessories', emoji: '🔌' },
  { value: 'insurance', label: 'Insurance', emoji: '🛡️' },
  { value: 'tyres', label: 'Tyres & Service', emoji: '🔧' },
  { value: 'detailing', label: 'Detailing & Painting', emoji: '🎨' },
  { value: 'solar', label: 'Solar Systems', emoji: '☀️' },
  { value: 'other', label: 'Other', emoji: '📦' },
]

/** Set of valid category slugs — use for API validation. */
export const CATEGORY_VALUES: Set<string> = new Set(CATEGORIES.map((c) => c.value))

/** slug → display label. */
export const CATEGORY_LABELS: Record<string, string> = Object.fromEntries(
  CATEGORIES.map((c) => [c.value, c.label]),
)
